export enum Genre {
  Downbeat = 'Dwnbt',
  Ambient = 'Amb',
}
